export default __webpack_public_path__ + "static/media/01_DAIF_Data_04_07.e00e3567.mp4";